export default "__VITE_ASSET__D615s4lE__"